import Card from '@/components/card/card-component';
import QuoteDetailDropdown from '@/components/quote-detail-dropdown/quote-detail-dropdown-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import { SubheaderText } from '@/utils/global-fonts';
import { useFieldArray, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

const GreyLine = styled.div`
  display: flex;
  height: 1px;
  background-color: ${({ theme }) => theme.COLOR_GREY5};
`;

/**
 * Details form for the Quote Summary page - Details Tab.
 * @file DetailsForm.jsx
 * @returns {JSX.Element} The rendered Details Form component.
 */
const QuoteDetailsForm = () => {
  const {
    formState: { isLoading: formLoading },
    control,
  } = useFormContext();

  const { fields: details } = useFieldArray({
    name: 'quote_modules_details',
    control,
  });

  const detailDropdownArray = details?.map((item) => {
    const defaultOption = item?.options?.find(
      (option) => option?.defualtOption === true,
    )?.value;

    const updatedDetail = {
      ...item,
      defaultOption,
    };

    return updatedDetail;
  });

  return (
    <>
      <Card margin="8px 0px 8px 0px" borderRadius="4px">
        <SubheaderText>Quote Number</SubheaderText>
        <GreyLine />
        <Input
          label="Quote Number"
          placeholder="Quote Number"
          name="quote.quote_number"
        />
      </Card>
      {detailDropdownArray?.map((module, index) => (
        <QuoteDetailDropdown
          key={module.id}
          heading={module.title}
          description={module?.description}
          name={`quote_modules_details.${index}`}
          dropdownData={module.options}
          loading={formLoading}
        />
      ))}
    </>
  );
};

export default QuoteDetailsForm;
